module.exports = __webpack_public_path__ + "static/media/M1-21-Halfdan-Galadris-cod130.d1ae746b.png";